export const OTP_COUNTDOWN_TIME = 60;
export const OTP_COUNTDOWN_TIME_IN_TEST_ENVIRONMENT = 5;

export enum OtpType {
  /**
   * No Channel represents the case where user has to select an OTP channel first instead of sending OTP directly through a specific channel, and is used in the following scenario:
   * * In FE request to BE to indicate whether FE support the above work flow
   * * From BE response to FE to signify the starting of the above work flow
   */
  NoChannel = 0,
  Sms = 1,
  Voice = 2,
  WhatsApp = 3,
  Email = 4,
  Zalo = 5,
  Viber = 6,
  WhatsappAuthLink = 9,
}

export enum AuthKeyType {
  Phone = 'phone',
  Email = 'email',
}

export enum DialogType {
  None = 'None',
  Captcha = 'Captcha',
  VoiceOtpConfirmation = 'VoiceOtpConfirmation',
  WhatsAppOtpConfirmation = 'WhatsAppOtpConfirmation',
  ViberOtpConfirmation = 'ViberOtpConfirmation',
  ZaloOtpConfirmation = 'ZaloOtpConfirmation',
  SwitchChannelConfirmation = 'SwitchChannelConfirmation',
}

export enum SendOtpResult {
  Success,
  NeedCaptcha,
  NeedVoice,
  OtpServiceUnavailable,
  OtpChannelUnavailable,
  Error,
}

export enum OtpTransitionState {
  Init = 'Init',
  RequireOtp = 'RequireOtp',
  EnforceVoiceOtp = 'EnforceVoiceOtp',
  SelectOtpChannel = 'SelectOtpChannel',
  SelectOtpChannelInitial = 'SelectOtpChannelInitial',
  Success = 'Success',
  ServiceUnavailable = 'ServiceUnavailable',
}

export enum UseCase {
  Otp = 'Otp',
  WhatsappAuthLink = 'WhatsappAuthLink',
}
